<template>
  <b-row>
    <b-col cols="12" sm="12">
      <b-card class="mx-auto" tile>
        <InputBuscar :filter="filter" @input="filter = $event">
          <BotonAgregar @mostrarModalAgregar="irAgregar" :textoBoton="$t('Gral.agregarDispo')" :iconBoton="iconBoton" />
        </InputBuscar>
        <b-row>
          <div class="col-md-12">
            <span style="font-weight: 600;" class="titleTabla">Dispositivos habilitados</span>
            <BaseTable tableClass="mb3 tbldispositivos tabla-dispositivos" :items="dispositivosTodos"
              :fields="translatedHeaders" :currentPage="currentPage" :perPage="perPage" :filter="filter"
              @filtered="onFiltered" :total-rows="totalRows">
              <template #cell(Usuarios)="data">
                <div v-if="data.item.usuarios.length > 0">
                  <span v-for="(usuario, id) in data.item.usuarios" :key="id">
                    {{ usuario.matricula }}
                    <span v-if="id != Object.keys(data.item.usuarios).length - 1">, </span>
                  </span>
                </div>
                <div v-else>{{ $t('vDispositivos.sinUsuarios') }}</div>
              </template>
              <template #cell(Acciones)="data">
                <div class="d-flex flex-row align-items-center">
                  <div class="p-1" v-if="isMaster">
                    <b-form-checkbox style="margin-top: -4px !important;" switch v-model=data.item.habilitado
                      @click.native="deviceDisabled(data.item)" v-b-tooltip.hover :title="$t('Gral.deshabilitar')">
                    </b-form-checkbox>
                  </div>
                  <div class="p-1" v-else>
                    <b-button variant="link" class="p-0 border-0 shadow-none text-reset"  @click="disableDispositivoAdmin(data.item)"
                    v-b-tooltip.hover :title="$t('Gral.eliminar')">
                      <feather type="trash-2" class="feather-sm mr-2"></feather>
                    </b-button>
                  </div>
                  <div class="p-1">
                    <b-button variant="link" class="p-0 border-0 shadow-none text-reset"  @click="editar(data.item)"  v-b-tooltip.hover :title="$t('Gral.editar')">
                      <feather type="edit" class="feather-sm mr-2"></feather>
                    </b-button>
                  </div>
                  <div class="p-1">
                    <b-button variant="link" class="p-0 border-0 shadow-none text-reset"  @click="generarLink(data.item)"
                     v-b-tooltip.hover :title="$t('vDispositivos.generarLink')">
                      <feather type="share-2" class="feather-sm mr-2"></feather>
                    </b-button>
                  </div>
                </div>
              </template>
            </BaseTable>
          </div>

          <div v-if="checkMasterUser() && noFilter()" class="col-md-12">
            <InputBuscar :filter="filter1" @input="filter1 = $event" style="margin-bottom: 0.8rem" />
            <span style="font-weight: 600;" class="titleTabla">Dispisitivos deshabilitados</span>
            <BaseTable tableClass="mb3 tbldispositivos tabla-dispositivos" :items="dispositivosDesh"
              :fields="translatedCabeceras" :currentPage="currentPageDesh" :perPage="perPageDesh" :filter="filter1"
              @filtered="onFilteredDeshabilitar" :total-rows="totalRowsDesh">
              <template #cell(Acciones)="data">
                <div class="d-flex flex-row align-items-center">
                  <div class="p-1">
                    <b-form-checkbox style="margin-top: -4px !important;" switch v-model=data.item.habilitado
                      @click.native="enabledDevice(data.item)" v-b-tooltip.hover :title="$t('Gral.habilitar')">
                    </b-form-checkbox>
                  </div>
                  <div class="p-1">
                    <b-button variant="link" class="p-0 border-0 shadow-none text-reset"  @click="removeDevice(data.item)" v-b-tooltip.hover :title="$t('Gral.eliminar')">
                      <feather type="trash-2" class="feather-sm mr-2"></feather>
                    </b-button>
                  </div>
                </div>
              </template>
            </BaseTable>
          </div>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
<script src="https://code.jquery.com/jquery-3.3.1.min.js"></script>
<script src="https://code.jquery.com/ui/1.12.1/jquery-ui.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/sweetalert2@8.2.6/dist/sweetalert2.all.min.js"
  integrity="sha256-Ry2q7Rf2s2TWPC2ddAg7eLmm7Am6S52743VTZRx9ENw=" crossorigin="anonymous"></script>
<link rel="stylesheet" href="https://code.jquery.com/ui/1.12.1/themes/start/jquery-ui.css" />

<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/2.2.4/jquery.min.js"></script>
<script src="extensions/auto-refresh/bootstrap-table-auto-refresh.js"></script>

<script>
import { mapState } from "vuex";
import DevicesDataService from "@/services/DevicesDataService";
import UsersDataService from "@/services/UsersDataService";
import PosicionesDataService from "../../../services/PosicionesDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.css';
import $ from 'jquery'
import * as Utils from "../../../utils/Utils"
import Crypto from "../../../services/Crypto";
import { verificarAcceso } from '../../../utils/Session';
import BaseTable from "../../components/BaseTable.vue";
import InputBuscar from "../../components/InputBuscar.vue";
import BotonAgregar from "../../components/BotonAgregar.vue";

export default {
  components: {
    BotonAgregar, 
    InputBuscar, 
    BaseTable
  },
  async beforeCreate(){
    verificarAcceso();
    
    if(!sessionStorage.getItem('rol') ||  sessionStorage.idRol === process.env.VUE_APP_ID_USUARIO_FINAL){
      this.$router.push({
        path: "/monitoreo"
      });
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer)
          toast.addEventListener('mouseleave', this.$swal.resumeTimer)
        }
      });

      Toast.fire({
        icon: 'error',
        title: this.$t('vDispositivos.noPermisos')
      });
    }
  },
  name: "dispositivos_list",
  data(){
    return{
      rolActual: localStorage.getItem('email'),
      estadoRol: localStorage.getItem('rol'),
      dispositivosTodos: [],
      usuariosTodos: [],
      filter: null,
      filter1: null,
      headers: [
        {
          key: 'nombre',
          label: 'idEquipo',
          sortable: true,
          'class': 'largo-columna',
        },
        {
          key: 'nombreGpsModel',
          label: 'modelo',
          sortable: true,
        },
        {
          key: 'imei',
          label: 'imei',
          sortable: true,
        },
        {
          key: 'telefono',
          label: 'telefono',
          sortable: true,
        },
        {
          key: 'Usuarios',
          label: 'usuarios'
        },
        {
          key: 'tipo',
          label: 'tipo',
          sortable: true,
        },
        {
          class: 'largo-columna-acciones',
          key: "Acciones",
          label: "acciones"
        }
      ],
      cabeceras: [],
      totalRows: 1,
      totalRowsDesh: 1,
      currentPage: 1,
      currentPageDesh: 1,
      perPage: 10,
      perPageDesh: 10,
      accion: '',
      usuarioLogueado: JSON.parse(sessionStorage.getItem('usuarioLogueado')),
      key: "",
      dispositivosDesh: [],
      flag: false,
      iconBoton: 'smartphone'
    };
  },
  async created() {
    const sToken = sessionStorage.getItem("token")
    const validToken = await AccionesDataService.validarTokenExistenteAllowList(sToken,this.key);
    
    if (!validToken) {
      this.cerrarSesion();
    }else{
      this.getGPSDevices();
      if(this.checkMasterUser()){
        this.getDisabledDevices();
      }
    }

    
  },
  computed:{
    ...mapState(['locale']),
    translatedHeaders() {
      // Mapea y traduce las etiquetas del arreglo headers.
      return this.headers.map(header => {
        if (typeof header === 'object' && header.label) {
          return {
            ...header,
            label: this.$t(`tableHeaders.${header.label}`)
          };
        } else {
          return header;
        }
      });
    },
    translatedCabeceras() {
      // Mapea y traduce las etiquetas del arreglo headers.
      return this.cabeceras.map(cabecera => {
        if (typeof cabecera === 'object' && cabecera.label) {
          return {
            ...cabecera,
            label: this.$t(`tableHeaders.${cabecera.label}`)
          };
        } else {
          return cabecera;
        }
      });
    },

    isMaster(){
      return sessionStorage.getItem('idRol') === process.env.VUE_APP_ID_MASTER
    }
  },
  mounted() {
    this.key = sessionStorage.getItem('key')
  },
  methods: {
    cerrarSesion() {
      console.log("entro a cerrarSesion****");
      

      //Cancela TODAS las peticiones pendientes
      abortController.abort();
      abortController = new AbortController(); // crear uno nuevo para futuras sesiones

      sessionStorage.clear();
      localStorage.clear();
      localStorage.removeItem("tokenSesion");
      localStorage.removeItem("servidor");
      localStorage.removeItem("aciqui_instance");

      destruirAlerta();
      if (router.currentRoute.name !== "Login") {
        router.replace({ name: "Login" });
      }
    },

    /** s
     * Método encargado de verificar si el usuario logueado
     * corresponde a un usuario Master.
     */
    checkMasterUser(){
      return sessionStorage.idRol === process.env.VUE_APP_ID_MASTER;
    },
    noFilter(){
      return sessionStorage.usuarioFiltro === "" ? true : false;
    },
    /** 
     * Método que permite conocer sí un usuario está visualizando la interfaz
     * del sistema desde la perspectiva de otro usuario.
     */
    isViewingAsAnotherUser(){
      return sessionStorage.usuarioFiltro != "";
    },

    async getDisabledDevices(){
      try{
        const response = await DevicesDataService.getDisabledDevices();
        const decoded = await Crypto.desencriptar(response.data, this.key);
        this.dispositivosDesh = decoded.map(this.getDisplayDispositivoDesh);
        this.totalRowsDesh = this.dispositivosDesh.length;
        if((this.totalRowsDesh > 0)) this.flag = true;
        else this.flag = false;
        this.cabeceras=[
          {
            key: 'nombre',
            label: 'idEquipo',
            sortable: true,
            'class': 'largo-columna',
          },
          {
            key: 'imei',
            label: 'imei',
            sortable: true,
          },
          {
            key: 'telefono',
            label: 'telefono',
            sortable: true,
          },
          {
            key: 'nombreGpsModel',
            label: 'modelo',
            sortable: true,
          },
          {
            key: 'tipo',
            label: 'tipo',
            sortable: true,
          },
          {
            key: 'area.nombre',
            label: 'grupo',
            sortable: true,
          },
          {
            key: "Acciones",
            label: "acciones"
          }
        ]
      }catch(err){
        console.error('Error al obtener los dispositivos deshabilitados')
      }
    },
    
    

    getGPSDevices() {
      DevicesDataService.getAll()
        .then(async response => {
          const decoded = await Crypto.desencriptar(response.data, this.key);
          let dispositivos = decoded.map(this.getDisplayDispositivo);
          

          const esMaster = this.checkMasterUser();
          const viendoComoOtro = this.isViewingAsAnotherUser();

          //CASO: MASTER
          if (esMaster) {
            if (viendoComoOtro) {
              const user = JSON.parse(sessionStorage.usuarioFiltro);

              if (user.rol.id === process.env.VUE_APP_ID_ADMINISTRADOR) {
                //Master viendo user administradores
                dispositivos = this.filtrarDispositivosPorAreas(dispositivos, user.id);

              } else {
                //Master viendo usuario final
                this.$router.push({ path: "/monitoreo" });
                Utils.generalSweetAlert(this.$t('vDispositivos.noPermisos'), "error");
                return;
              }
            } else {
              // MASTER real
              this.setHeadersMaster();
            }
          }
          //CASO: ADMINISTRADOR
          else {
            const userStr = sessionStorage.getItem('usuarioLogueado');
            if (!userStr) return;

            const user = JSON.parse(userStr);
            
            dispositivos = this.filtrarDispositivosPorAreas(dispositivos, user.id);
            
          }

          this.dispositivosTodos = dispositivos;
          this.totalRows = dispositivos.length;
        })
        .catch(e => {
          
          if (e.toString().includes("401")) {
            this.$router.push({ path: "/" });
            Utils.generalSweetAlert(this.$t('Gral.msgSesion'), "warning");
          } else {
            Utils.generalSweetAlert(
              this.$t('vMonitoreo.msgErrBuscarDispositivos'),
              "error"
            );
          }
        });
    },

    filtrarDispositivosPorAreas(dispositivos, adminId) {
      if (!adminId) return [];

      return dispositivos.filter(d =>
        d.area &&
        Array.isArray(d.area.adminIds) &&
        d.area.adminIds.includes(adminId)
      );
    },


    setHeadersMaster() {
      this.headers = [
        { key: 'nombre', label: 'idEquipo', sortable: true, class: 'largo-columna' },
        { key: 'nombreGpsModel', label: 'modelo', sortable: true },
        { key: 'imei', label: 'imei', sortable: true },
        { key: 'telefono', label: 'telefono', sortable: true },
        { key: 'Usuarios', label: 'usuarios' },
        { key: 'tipo', label: 'tipo', sortable: true },
        { key: 'Acciones', label: 'acciones' }
      ];
    },


    getDisplayDispositivo(dispositivo) {
      let imeid = "IMEI:"; //Texto para concatenar con el dato IMEI/Id
      let tiempo = 0;
      let nombreModelo = "No asignado";

      if(dispositivo.compartirHasta)
        tiempo = dispositivo.compartirHasta;

      switch (dispositivo.modelo) {
        case "TKSTAR":
          imeid = "Id:"
          break;
        case "TK108":
        case "GPSAU":
          imeid = "IMEI:"
          break;
      } 
      
      if(dispositivo.model) //si tiene asignado un modelo, se muestra
          nombreModelo = dispositivo.model.modelo;

      return {
        id: dispositivo.id,
        nombre: dispositivo.nombre,
        contrasena: dispositivo.contrasena,
        habilitado: dispositivo.habilitado,
        modelo: dispositivo.modelo,
        nombreGpsModel: nombreModelo,
        modeloGps: dispositivo.model,
        imei:  imeid + ' ' + dispositivo.imei,
        telefono: dispositivo.dialCode 
            ? `(${dispositivo.dialCode}) ${dispositivo.telefono}`
            : dispositivo.telefono,
        usuarios: dispositivo.usuarios === null ? [] : dispositivo.usuarios,
        fechaInicio: null,
        area: dispositivo.area,
        compartirLink:dispositivo.compartirLink,
        compartirHasta: tiempo,
        serial: dispositivo.serial,
        tipo: dispositivo.tipo,
        iso: dispositivo.iso
      };
    },

    getDisplayDispositivoDesh(dispositivo) {
      let imeid = "IMEI:"; //Texto para concatenar con el dato IMEI/Id
      let nombreModelo = "No asignado";

      if(dispositivo.model) //si tiene asignado un modelo, se muestra
          nombreModelo = dispositivo.model.modelo;

      switch (dispositivo.modelo) {
        case "TKSTAR":
          imeid = "Id:"
          break;
        case "TK108":
          imeid = "IMEI:"
          break;
      } 
      return {
        id: dispositivo.id,
        nombre: dispositivo.nombre,
        habilitado: dispositivo.habilitado,
        nombreGpsModel: nombreModelo,
        imei:  imeid + ' ' + dispositivo.imei,
        telefono: dispositivo.telefono,
        area: dispositivo.area,
        serial: dispositivo.serial,
        tipo: dispositivo.tipo,
      };
    },

    editar(datos) {
      let imei = datos.imei.split(' '); //Ya que se concatena una descripción antes del dato, ahora hay que separar las cadenas para poder obtener el IMEI real
      imei = imei[1]; //se toma la segunda posición del array separado, ya que la primera [0] corresponde a la descripción

      let tel = datos.telefono.split(' ')
      tel = tel[1]

      sessionStorage.setItem("imei", imei);
      this.$router.push({name:"Editar dispositivo", 
        params: {
          "id": datos.id,
          "nombre":datos.nombre,
          "contrasena":datos.contrasena, 
          "modelo": datos.modelo, 
          "modeloGps": datos.modeloGps, 
          "imei": imei, 
          "usuarios": datos.usuarios, 
          "telefono": tel,
          "area": datos.area, 
          "vistaAnterior": "/dispositivos", 
          "compartirLink": datos.compartirLink, 
          "compartirHasta": datos.compartirHasta,
          "serial": datos.serial,
          "tipo": datos.tipo,
          "iso": datos.iso
        }});
    },

    async generarLink(datos) {
      try{
        const response = await PosicionesDataService.getPositionByDevice(datos.id, this.key);
        const decoded = await Crypto.desencriptar(response.data, this.key);
        if(!decoded){
          const valueDialog = await Utils.customizedSweetAlert( this.$t('vDispositivos.msgNoPosicionesLink'), "warning");
          if(valueDialog){
            this.continuarGeneracionLink(datos);
          }
        }else{
          this.continuarGeneracionLink(datos);
        }
      }catch(e){
        console.error(e);
      }
    },

    continuarGeneracionLink(datos){
      let imei = datos.imei.split(' '); //Ya que se concatena una descripción antes del dato, ahora hay que separar las cadenas para poder obtener el IMEI real
      imei = imei[1]; //La índice [1] corresponde al valor IMEI /ID del dispositivo, [0] corresponde a la descripcion del campo
      sessionStorage.setItem("imei", imei);

      const params = {
        "id": datos.id,
        "nombre": datos.nombre,
        "contrasena": datos.contrasena,
        "modelo": datos.modelo, // Marca del gps
        "modeloGps": datos.modeloGps, // Modelo del gps
        "imei": imei,
        "usuarios": datos.usuarios,
        "telefono": datos.telefono,
        "area": datos.area,
        "compartirLink": datos.compartirLink,
        "compartirHasta": datos.compartirHasta
      };

      this.$router.push({name:"Generar link", params: params});
    },

    async removeDevice(datos){
      try{
        const responseDialog = await Utils.customizedSweetAlert(`¿Está seguro que desea eliminar el dispositivo ${datos.nombre}? ¡Esta acción es irreversible!`, "warning");
        if(responseDialog){
          const extractedImei = datos.imei.split(' ')[1];
          const txt = extractedImei.length == 10 ? 'ID:' : 'IMEI:';

          await DevicesDataService.delete(datos.id, this.key);
          this.accion = 'Eliminó el dispositivo ' + datos.nombre + ' con ' + txt + ' ' + extractedImei;
          this.registrarAccion();
          this.getDisabledDevices();
          Utils.generalSweetAlert(this.$t('vDispositivos.msgDelDispo'), "success");
        }
      }catch(err){
        Utils.generalSweetAlert(this.$t('vDispositivos.errDelDispo'), "error");
        console.error(err)
      }
    },

    async disableDispositivoAdmin(datos){
      try {
        const responseDialog = await Utils.customizedSweetAlert(`¿Está seguro que desea eliminar el dispositivo ${datos.nombre}?`, "warning");

        if(responseDialog){
          sessionStorage.setItem("id", datos.id);

          const extractedImei = datos.imei.split(' ')[1];
          const txt = extractedImei.length == 10 ? 'ID:' : 'IMEI:';

          const infoDevice = {
            id: datos.id,
            status: false, //bandera para deshabilitar el dispositivo en bk
          }

          await DevicesDataService.toggleGpsStatus(infoDevice, this.key);
          this.accion = 'Deshabilitó el dispositivo ' + datos.nombre + ' con ' + txt + ' ' + extractedImei;
          this.registrarAccion();
          this.getGPSDevices();
          this.getDisabledDevices();
          Utils.generalSweetAlert("Se eliminó el dispositivo " + datos.nombre, "success");

        }else{
          datos.habilitado = !datos.habilitado;
        }
        
      } catch (error) {
        if(error.response){
          if(error.response.status == 400){
            Utils.generalSweetAlert(this.$t('vDispositivos.msgErrDelDispo'), "error");
          }
        }else{
          Utils.generalSweetAlert(this.$t('vDispositivos.errDelDispo'), "error");
        }
        datos.habilitado = !datos.habilitado;
      }
    },

    async deviceDisabled(datos) {
      try{
        const responseDialog = await Utils.customizedSweetAlert("¿Desea deshabilitar el dispositivo " + datos.nombre + "?", "warning");
        if(responseDialog){
          //TODO:De momento no parece tener impacto en todo el sistema
          sessionStorage.setItem("id", datos.id);

          const extractedImei = datos.imei.split(' ')[1];
          const txt = extractedImei.length == 10 ? 'ID:' : 'IMEI:';

          const infoDevice = {
            id: datos.id,
            status: false, //bandera para deshabilitar el dispositivo en bk
          }

          await DevicesDataService.toggleGpsStatus(infoDevice, this.key);
          this.accion = 'Deshabilitó el dispositivo ' + datos.nombre + ' con ' + txt + ' ' + extractedImei;
          this.registrarAccion();
          this.getGPSDevices();
          this.getDisabledDevices();
          Utils.generalSweetAlert("Se deshabilitó el dispositivo " + datos.nombre, "success");

        }else{
          datos.habilitado = !datos.habilitado;
        }
      }catch(e){
        if(e.response){
          if(e.response.status == 400){
            Utils.generalSweetAlert(this.$t('vDispositivos.msgErrDelDispo'), "error");
          }
        }else{
          Utils.generalSweetAlert(this.$t('vDispositivos.errDelDispo'), "error");
          console.error('No se pudo realizar la petición ' + e);
        }
        datos.habilitado = !datos.habilitado;
      }
    },

    async enabledDevice(datos){
      try{
        const valueDialog = await Utils.customizedSweetAlert("¿Desea habilitar el dispositivo " + datos.nombre + "?", "warning");
        if(valueDialog){
          const extractedImei = datos.imei.split(' ')[1];
          const txt = extractedImei.length == 10 ? 'ID:' : 'IMEI:';

          const infoDevice = {
            id: datos.id,
            status: true, //bandera para habilitar el dispositivo en bk
          }

          await DevicesDataService.toggleGpsStatus(infoDevice, this.key);
          this.accion = 'Habilitó el dispositivo ' + datos.nombre + ' con ' + txt + ' ' + extractedImei;
          this.registrarAccion();
          this.getGPSDevices();
          this.getDisabledDevices();
          Utils.generalSweetAlert("Se habilitó el dispisitivo " + datos.nombre, "success");
        }else{
          datos.habilitado = !datos.habilitado;
        }
      }catch(err){
        console.error(err);
        Utils.generalSweetAlert("Error al habilitar el dispositivo ","Error");
      }
    },

    irAgregar(){
      this.$router.push({
        path: "/AddDispositivo"
      });
    },

    registrarAccion(){   
        const data = {
          usuario: this.usuarioLogueado,
          accion: this.accion + sessionStorage.infoDevice,
          fechaCreacion: new Date(),
          tipo: 'accion',
        };
        AccionesDataService.create(data, this.key); 
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems
      this.currentPage = 1
    },

    onFilteredDeshabilitar(filteredItems) {
      this.totalRowsDesh = filteredItems
      this.currentPageDesh = 1
    },
  }
};
</script>

<style>
.card-body {
  margin: 0.7rem;
}

.largo-columna {
  width: 250px;
}

.largo-columna-2 {
  width: 200px;
}

.largo-columna-acciones {
  width: 150px;
}

@media only screen and (max-width: 1600px) {
  .largo-columna-acciones {
    width: 200px
  }
}

@media screen and (max-width: 991px) {
  .largo-columna-acciones {
    width: 200px
  }
}

@media (max-width: 959px) {

  .boton-limpiar,
  .boton-agregar {
    margin-top: -16px;
  }

  .tabla-dispositivos {
    margin-top: -8px;
  }
}

@media (min-width: 960px) {

  .boton-limpiar,
  .boton-agregar {
    margin-top: 0px !important;
  }
}

@media screen and (max-width: 767px) {
  .largo-columna-acciones {
    width: 100px;
  }
}

@media screen and (max-height: 450px) {
  .largo-columna-acciones {
    width: 100px;
  }
}

@media (max-width: 991.98px) and (max-height: 950px) {

  /* Force table to not be like tables anymore */
  .tbldispositivos table,
  .tbldispositivos thead,
  .tbldispositivos tbody,
  .tbldispositivos th,
  .tbldispositivos td,
  .tbldispositivos tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .tbldispositivos thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .tbldispositivos tr {
    border: 1px solid #ccc;
  }

  /* Se forza a que las columnas de la tabla se comporten como filas */
  .tbldispositivos td {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 5%;
  }

  /* Ahora como cabecera de tabla */
  .tbldispositivos td:after {
    position: absolute;
    top: 6px;
    left: 6px;
    width: 70%;
    padding-right: 10px;
    white-space: nowrap;
  }

  /* Se asignan los nombres a las cabeceras, las cuales son dinamicas dependiendo del usuario */
  .tbldispositivos td:first-child:before {
    content: "Dispositivo: ";
  }

  .tbldispositivos td:nth-of-type(2):before {
    content: "Modelo: ";
  }

  .tbldispositivos td:nth-of-type(3):before {
    content: "";
  }

  .tbldispositivos td:nth-of-type(4):before {
    content: "Teléfono: ";
  }

  .tbldispositivos td:nth-of-type(5):before {
    content: "Usuarios: ";
  }

  .tbldispositivos td:nth-of-type(6):before {
    content: "Grupo: ";
  }

  .tbldispositivos td:last-child:before {
    content: "Acciones: ";
  }
}



</style>
